import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckIcon from '@mui/icons-material/Check';
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { RabbitMQAction } from 'types/rabbitMQ';

type Props = {
  onReadQueue: () => void;
  onApply: () => void;
  onSetAllActions: (action: RabbitMQAction) => void;
  isLoading: boolean;
  hasPendingActions: boolean;
  hasMessages: boolean;
};

function ActionButtons({
  onReadQueue,
  onApply,
  onSetAllActions,
  isLoading,
  hasPendingActions,
  hasMessages
}: Props) {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
      <Tooltip title="Lire les messages d'erreur (lecture non destructive)">
        <span>
          <Button
            variant="contained"
            color="primary"
            startIcon={<RefreshIcon />}
            onClick={onReadQueue}
            disabled={isLoading}
          >
            Lire la file d'erreur
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Sélectionner l'action Rejouer sur tous les messages">
        <span>
          <Button
            variant="outlined"
            color="success"
            startIcon={<ReplayIcon />}
            onClick={() => onSetAllActions('requeue')}
            disabled={isLoading || !hasMessages}
          >
            Tout rejouer
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Sélectionner l'action Supprimer sur tous les messages">
        <span>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteSweepIcon />}
            onClick={() => onSetAllActions('delete')}
            disabled={isLoading || !hasMessages}
          >
            Tout supprimer
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Réinitialiser la sélection (aucune action)">
        <span>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<RestartAltIcon />}
            onClick={() => onSetAllActions('none')}
            disabled={isLoading || !hasPendingActions}
          >
            Tout réinitialiser
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Appliquer les actions sélectionnées (rejouer / supprimer)">
        <span>
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckIcon />}
            onClick={onApply}
            disabled={isLoading || !hasPendingActions}
          >
            Appliquer
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
}

export default ActionButtons;
